import { Journey } from "@vanguard/otel-web-tools";

const BUSINESS_AREA = "estate-planning";

export const JOURNEYS = {
  pageLoad: {
    businessArea: BUSINESS_AREA,
    flow: "page_load",
    stage: "bootstrap",
  },
  addBank: {
    businessArea: BUSINESS_AREA,
    flow: "add_account",
    stage: "submit",
    flowVariation: "bank",
  },
  addInvestment: {
    businessArea: BUSINESS_AREA,
    flow: "add_account",
    stage: "submit",
    flowVariation: "investment",
  },
  addRetirement: {
    businessArea: BUSINESS_AREA,
    flow: "add_account",
    stage: "submit",
    flowVariation: "retirement",
  },
  addRealEstate: {
    businessArea: BUSINESS_AREA,
    flow: "add_account",
    stage: "submit",
    flowVariation: "real_estate",
  },
  addTrust: {
    businessArea: BUSINESS_AREA,
    flow: "add_account",
    stage: "submit",
    flowVariation: "trust",
  },
  addLiability: {
    businessArea: BUSINESS_AREA,
    flow: "add_liability",
    stage: "submit",
  },
  editAccount: {
    businessArea: BUSINESS_AREA,
    flow: "edit_account",
    stage: "submit",
  },
  deleteAccount: {
    businessArea: BUSINESS_AREA,
    flow: "delete_account",
    stage: "confirm",
  },
  vanillaSync: {
    businessArea: BUSINESS_AREA,
    flow: "vanilla_sync",
    stage: "initiate",
  },
} as const satisfies Record<string, Journey>;
